/** Scoring profiles and the model registry. Owner: settings-profiles. Add keys; never rename. */
export const profileKeys = {
  all: ['profiles'] as const,
  /** `GET /api/profiles`. */
  list: () => ['profiles', 'list'] as const,
  details: () => ['profiles', 'detail'] as const,
  /** `GET /api/profiles/:id`. */
  detail: (profileId: string) => ['profiles', 'detail', profileId] as const,
  /** `GET /api/profiles/:id/versions`. */
  versions: (profileId: string) => ['profiles', 'detail', profileId, 'versions'] as const,
  version: (profileId: string, version: number) =>
    ['profiles', 'detail', profileId, 'versions', version] as const,
  /** `GET /api/models`: the model registry with health. */
  models: () => ['profiles', 'models'] as const,
  /** Test tab (DR-PRF-08): candidates with a finished search, by search text. */
  testCandidates: (q: string, evaluation?: 'only') =>
    ['profiles', 'test', 'candidates', q, evaluation ?? 'all'] as const,
  /** Test tab: the scored vacancies of one run to test on. */
  testVacancies: (runId: string) => ['profiles', 'test', 'vacancies', runId] as const,
};
